// MEM: clickable swatches swap card image
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.mem-card-swatch[data-image]');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();
  var card = btn.closest('.card-wrapper, .grid__item, .card');
  if (!card) return;
  var img = card.querySelector('.card__media img, .media img');
  if (!img) return;
  var newSrc = btn.getAttribute('data-image');
  if (!newSrc) return;
  // Smooth fade swap
  img.style.transition = 'opacity 220ms ease';
  img.style.opacity = '0';
  setTimeout(function () {
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = newSrc;
    img.onload = function () { img.style.opacity = '1'; };
  }, 220);
  // Mark active swatch
  card.querySelectorAll('.mem-card-swatch').forEach(function (b) { b.classList.remove('is-active'); });
  btn.classList.add('is-active');
});
